export enum ECheckingType {
  Qr = 1,
  Phone,
  Mail,
}
